export default __webpack_public_path__ + "static/media/american-express.09561af3.svg";